import React from 'react';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Plugin } from "@devexpress/dx-react-core";
import TableRowsIndexer from '../components/tableRowsIndexer';
import ExpandMoreIcon                         from '@material-ui/icons/ChevronRight';
import ExpandLessIcon                          from '@material-ui/icons/KeyboardArrowDown';
import {
  GroupingState,
  IntegratedGrouping,
  FilteringState,
  IntegratedFiltering,
  //DataTypeProvider,
  SelectionState,
  TreeDataState,
  CustomTreeData,
  IntegratedSelection,
  EditingState,
  SummaryState,
  IntegratedSummary,
RowDetailState,
SortingState,
IntegratedSorting,
} from '@devexpress/dx-react-grid';

import {
  Grid, VirtualTable,
  Table, TableHeaderRow, TableGroupRow, TableFilterRow, TableColumnVisibility, TableSelection, TableTreeColumn,
  TableColumnResizing, TableFixedColumns, TableInlineCellEditing,  TableSummaryRow, TableRowDetail, ExportPanel,
  Toolbar
} from '@devexpress/dx-react-grid-material-ui';
import {colores} from '../global'; 
import {IconButton,Typography } from '@material-ui/core';
//import {GridExporter} from '@devexpress/dx-react-grid-export';
import saveAs from 'file-saver';
import Button from '@material-ui/core/Button';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import ClearAll from '@material-ui/icons/ClearAll';

const Root = props => <Grid.Root style={{ height: "calc(100% - 20px)", border: "transparent solid 1px" }} {...props}/>;

const noDataCellComponent = ({ colSpan }) => (
  <td colSpan={colSpan}></td>
);

const LocalBodyComponent = (props) => {
  return <Table.TableBody {...props} />;
}

const LocalcontainerComponent= ({...props}) => {
  return (<div  style={{background: 'inherit'}} {...props}/>);
}

const LocalHeaderRowCellComponent = (props) => {
  return (<TableHeaderRow.Cell {...props} />);
}

const LocalHeaderRowComponent = ({style, ...props}) => {

  return (<Table.Row style={{ backgroundColor: colores.tabla.encabezado }} {...props} />);

}

const LocalTableRow = (idRowSelected, handleRowClick, idName, disabledAlternateColor) => ({selectByRowClick, rowIndex, highlighted, ...props}) => {

  const odd = !!(rowIndex % 2);
  if (idRowSelected !== undefined && handleRowClick !== undefined && idName !== undefined)
  {
    return (
      <Table.Row {...props}
        onClick={handleRowClick(props.tableRow.row[idName])}                 
        style={{
          cursor: 'pointer',
          backgroundColor: idRowSelected === props.tableRow.row[idName] ? 'rgb('+ colores.tabla.selection +')' : 
                           disabledAlternateColor ? undefined :
                           odd ? colores.tabla.alternateColorRow1 : colores.tabla.alternateColorRow2,                    
        }}
  
      />
    );

  }

  return (      
    <Table.Row {...props}
      style={{ 
      backgroundColor: disabledAlternateColor ? undefined : 
                        odd ? colores.tabla.alternateColorRow1 : colores.tabla.alternateColorRow2
      }}
    />
  );

}

const VirtualTable_cellComponentLocal = (props) => {  
  return (<Table.Cell {...props}/>);
};


const LocalColumnFixed_cellComponent = (props) => {
  return (<TableFixedColumns.Cell {...props} /> );
}


const LocalTableComponent = (props) => {
 return ( <Table.Table {...props} />  );
}

const LocalTableGroupRow_cellComponent = (props) =>{
return (<TableGroupRow.Cell  {...props}/>);
}

const LocalTableSelectionHeaderCellComponent = (props) => {
  return (<TableSelection.HeaderCell {...props} />);
}

const LocalTableSelectionCellComponent = (props) =>{
  return (<TableSelection.Cell  {...props}/>)
}


const LocalcellsEditingCellComponent = (props) =>{
  return (<TableInlineCellEditing.Cell {...props} />);
}


const LocalStubCellComponentTable = ({ colSpan,...props}) => {
  return (<Table.StubCell colSpan={props.tableColumn.key === "Symbol(flex)" ? 2 : colSpan} {...props} />);
}


const LocalTotalCellComponent = (props) => {
 return (<TableSummaryRow.TotalCell {...props} />);
}

const LocalItemComponent = (props)=>{
  return (<TableSummaryRow.Item style={{ fontSize: 12 }} {...props} />);
}

const LocalTableTreeColumn_checkboxComponent = (props) =>{
  return (<TableTreeColumn.Checkbox style={{ width: 26, height: 26, marginLeft: -3 }} {...props}/>);
}

const LocalExpandButtonComponent = (props) => {
  return (<TableTreeColumn.ExpandButton style={{ width: 22, height: 22, marginBottom: 3, marginTop: 3 }} {...props}/>);
}

const LocalTableTreeColumn_cellComponent = (props) =>{
  return (<TableTreeColumn.Cell {...props}/>);
}

const LocalFilterCellComponent = (props)=>{ 
  return (<TableFilterRow.Cell {...props} />);
}

const LocalEditorComponentFilter = (props)=>{ 
  return (<TableFilterRow.Editor style={{ marginTop: "0px" }} {...props}/>);
}

const LocalToggleButtonComponentFilter = (props)=>{
  return (<TableFilterRow.ToggleButton {...props} />);
}

const LocalGroupContentComponent = (props) =>{
  return (<TableGroupRow.Content {...props} />);
} 

const LocalGroupIconComponent = (props)=>{
  return (<TableGroupRow.Icon style={{ width: 22, height: 22, padding: 0 }} {...props}/>); 
}

const LocalIndentComponent = (props) => {
  return <TableTreeColumn.Indent {...props} />;
}

const LocaltoggleCellComponent= ({onToggle,expanded,...props}) => {
  return (
  <TableRowDetail.Cell {...props} style={{paddingTop:  0,paddingBottom: 0 ,background:'inherit'}}>
    <IconButton onClick={onToggle}>
      {expanded?<ExpandLessIcon/>:<ExpandMoreIcon />}
    </IconButton>
  </TableRowDetail.Cell>
  );
}

const LocalRowDetailCellComponent = ({ colSpan, ...props})=>{ 
  return (<TableRowDetail.Cell colSpan={colSpan + 1} {...props}/>)
} 

const Loading = () => {
  const divStyle ={
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(255, 255, 255, 0)'
  }
  const style = {
    position: 'absolute',
    fontSize: '20px',
    top: 'calc(45% - 10px)',
    left: 'calc(50% - 20px)'
  }
  return (
  <div style={divStyle}>
    <CircularProgress style={style} />
  </div>
  )
}

/*const onSave =(nombre)=> (workbook) => {
  workbook.xlsx.writeBuffer().then((buffer) => {
    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), nombre+'.xlsx');
  });
};*/

const ExportMenu = (quitarorden,tiene_orden,label_Toolbarexport)=> ({ children, onHide, ...restProps }) => {
  return (
    <div style={{alignItems:'center',justifyContent: 'center',display:'flex'}}>
    <Typography align='center' variant='body1' style={{color:'grey',left:0,position:'absolute',marginLeft:5,}}>
      <b>{label_Toolbarexport}</b>
    </Typography>
    <Button onClick={quitarorden} color='primary' variant='outlined'  style={{marginLeft:5,textTransform: 'none',paddingRight: 20,paddingLeft: 20}}
      disabled={!tiene_orden} startIcon={<ClearAll/>}
    >
      Quitar Ordenamiento
    </Button>
    </div>
  );
};


const SortingIcon = ({ direction }) => (
  direction === 'asc'? <ArrowUpward style={{ fontSize: '18px' }} />: <ArrowDownward style={{ fontSize: '18px' }} />
);

const SortLabel = ({ onSort, children, direction }) => (
  <TableHeaderRow.Cell onClick={onSort} style={{padding:0,border:'none',color:direction?colores.naranja:'inherit'}}>
    {children}
    {(direction && <SortingIcon direction={direction} />)}
  </TableHeaderRow.Cell>
);


export default class Tabla extends React.PureComponent {
  exporterRef=React.createRef();
  constructor (props) { 
    super(props);
    this.state = {
      columns: this.props.Columns,
      sorting: [],
      tiene_orden: false,
    };
  }

  quitarorden=()=>{
    this.setState({ sorting: [],tiene_orden: false });
  }

  rePaint = ()=>{    
   this.setState({ ...this.state, columns: this.props.Columns.slice() });
  }

  
  startExport =(options) => {
    this.exporterRef.current.exportGrid(options);
  };

  onSortingChange= (sorting)=>{    
    this.setState({ sorting: sorting,tiene_orden: true });
   }

  render() { 
    
    return (
      <Paper style={{ height: this.props.height, boxShadow: this.props.disableBoxShadow ? 'none' : undefined, position: this.props.loading ? "relative" : undefined}} variant={!this.props.disableBoxShadow ? "outlined" : undefined}>
        <Grid
          rows={this.props.loading ? [] : this.props.Rows}
          columns={this.state.columns}
          rootComponent={Root}
          getRowId={this.props.getRowId} 
        >
        <SortingState sorting={this.state.sorting} onSortingChange={this.onSortingChange}/>
        <IntegratedSorting />
      {
        (()=>{ 
          if (this.props.DataTypeProviders !== undefined){
              return (this.props.DataTypeProviders)
            }          
         })()
      }
      {
        (() => {

          if (this.props.TableNameTreeColum !== undefined)
          {
            return (
              <TreeDataState 
                      onExpandedRowIdsChange={this.props.OnExpandedRowIdsChange} 
                      expandedRowIds={this.props.ExpandedRowIds === undefined ? [] : this.props.ExpandedRowIds}
                />
              
            )
          }
        })()
      }
      {
        (()=>{
          if (this.props.enabledFilterRows === true)
          {
                return (
                  <FilteringState
                    defaultFilters={[]}
                    filters={this.props.Filters} 
                    onFiltersChange={this.props.onFiltersChange}                    
                  />
                );
          }
        })()    
      }    
        <SelectionState
            selection={this.props.Selection === undefined ? [] : this.props.Selection}
            onSelectionChange={this.props.ChangeSelection}
          />
          {
            (() => {
           
           if (this.props.Grouping !== undefined)
           {           
           return (   
            <GroupingState
              grouping={this.props.Grouping === undefined ? [] : this.props.Grouping}
              expandedGroups={this.props.ExpandedGroups === undefined ? [] : this.props.ExpandedGroups }
              onExpandedGroupsChange={this.props.ChangeExpandedGroups}
            />
           )
          }
          })()
          }
          {
            (() => {

            if (this.props.GetChildRows !== undefined)
            {
              return (
                      <CustomTreeData
                        getChildRows= {this.props.GetChildRows}
                      />
                )
              }
            })()
          }
          {
              (() => {
	                if (this.props.cellsEditing === true)
                  {
                    return (<EditingState onCommitChanges={this.props.commitChanges} />)
                  }
              })()
          }
          {
            (()=>{
                if (this.props.totalItems !== undefined || this.props.groupItems !== undefined)
                {  
                      return (
                        
                        <SummaryState
                           totalItems={this.props.totalItems === undefined ? [] : this.props.totalItems}
                           groupItems={this.props.groupItems === undefined ? [] : this.props.groupItems}
                        />                                            
                      );
                }                      
            })()
          }
          {
            (()=>{
              if (this.props.enabledFilterRows === true)
              {
              return (
                <IntegratedFiltering
                    columnExtensions={this.props.FilteringColumnExtensions}
                />
              );             
            }
            })()            
          }
          <IntegratedSelection highlightRow={false}/>
          {
          (() => {         
                if (this.props.Grouping !== undefined)
                {
                  return (
                  <IntegratedGrouping />
                  )
                }
            })()      
          }
          {
          (() => {      
               if (this.props.totalItems !== undefined || this.props.groupItems !== undefined)
               {
                  return (
                  <IntegratedSummary calculator={this.props.calculator} />
                  )
                }
            })()      
          }
          <VirtualTable
            columnExtensions={this.props.TableColumnExtensions === undefined ? [] : this.props.TableColumnExtensions}
            cellComponent={this.props.VirtualTable_cellComponent !== undefined ? this.props.VirtualTable_cellComponent : VirtualTable_cellComponentLocal }
            bodyComponent = {this.props.BodyComponent !== undefined ? this.props.BodyComponent : LocalBodyComponent }
            noDataCellComponent= {this.props.noDataCellComponent !== undefined ? this.props.noDataCellComponent : noDataCellComponent}
            tableComponent = {this.props.tableComponent !== undefined ? this.props.tableComponent : LocalTableComponent }
            height="auto"
            estimatedRowHeight={31} //{53}
            stubCellComponent={this.props.stubCellComponentTable !== undefined ? this.props.stubCellComponentTable : LocalStubCellComponentTable} 
            ref={this.props.vtRef} 
          />
          <TableSelection
            highlightRow
            showSelectionColumn={this.props.showSelectionColumn === undefined ? false : this.props.showSelectionColumn}
            rowComponent = {this.props.RowComponent !== undefined ? this.props.RowComponent : LocalTableRow(this.props.rowSelected, this.props.rowClick, this.props.getRowId !== undefined ? this.props.getRowId.toString().split(".")[1].replace("}","") : undefined, this.props.disabledAlternateRowColor)  }
            cellComponent = {this.props.tableSelectionCellComponent !== undefined ? this.props.tableSelectionCellComponent : LocalTableSelectionCellComponent } 
            showSelectAll = {this.props.showSelectAll === undefined ? false : this.props.showSelectAll} 
            headerCellComponent = {this.props.tableSelectionHeaderCellComponent !== undefined ? this.props.tableSelectionHeaderCellComponent : LocalTableSelectionHeaderCellComponent}           
            selectionColumnWidth={this.props.selectionColumnWidth === undefined ? 58 : this.props.selectionColumnWidth}
            />
          <TableColumnVisibility
            defaultHiddenColumnNames={this.props.DefaultHiddenColumnNames === undefined ? [] : this.props.DefaultHiddenColumnNames}
            hiddenColumnNames={this.props.hiddenColumnNames}
          />
          {
           (() => {
             if (this.props.columnWidths !== undefined)
             {
            return (
            <TableColumnResizing
             minColumnWidth={60}             
             defaultColumnWidths={this.props.columnWidths} 
             columnExtensions={this.props.columnExtensionsResizing}  
             onColumnWidthsChange={this.rePaint}      
            />           
            )
            }
            })()
          }
          {
          (() => {
          if (this.props.disableHeader === undefined || this.props.disableHeader === false)
          {        
          return (  
          <TableHeaderRow
            showSortingControls={this.props.showSorting}
            sortLabelComponent={SortLabel}
             cellComponent= {this.props.rowHeaderCellComponent !== undefined ? this.props.rowHeaderCellComponent : LocalHeaderRowCellComponent }
             rowComponent = {this.props.rowHeaderRowComponent !== undefined ? this.props.rowHeaderRowComponent : LocalHeaderRowComponent }
           />
          );         
          }
          })()
          }

	  {/*----------------------------------------------------------------RowDetail-----------------------------------------------*/}
          {
          (() => {
          if (this.props.RowDetail!==undefined)
          {
          return (  
          <RowDetailState
             expandedRowIds={this.props.ExpandedRowDetailIds}
             onExpandedRowIdsChange={this.props.onExpandedRowDetailIdsChange}
          />
          );         
          }
          })()
          }
          {
          (() => {
          if (this.props.RowDetail!==undefined)
          {
          return ( 
          <TableRowDetail
          contentComponent={this.props.RowDetail}
          //toggleColumnWidth={31}
          toggleCellComponent={LocaltoggleCellComponent}
          cellComponent={this.props.rowDetailCellComponent === undefined ? LocalRowDetailCellComponent : this.props.rowDetailCellComponent}
          />
          );       
          }
          })()
          }
          {/*----------------------------------------------------------------RowDetail-----------------------------------------------*/}
          {
          (() => {
            if (this.props.enabledFilterRows === true) {
            return (
              <TableFilterRow
                    cellComponent = {this.props.filterCellComponent === undefined ? LocalFilterCellComponent : this.props.filterCellComponent}
                    showFilterSelector = {this.props.showFilterSelector === undefined ? false : this.props.showFilterSelector}
                    messages ={this.props.messagesFilter === undefined ? { filterPlaceholder: ''} : this.props.messagesFilter}                    
                    editorComponent={this.props.editorComponentFilter === undefined ? LocalEditorComponentFilter : this.props.editorComponentFilter}
                    toggleButtonComponent={this.props.toggleButtonComponentFilter === undefined ? LocalToggleButtonComponentFilter : this.props.toggleButtonComponentFilter}
              />
             );
            }
           })()
       }     
        {
          (() => {        
            if (this.props.Grouping !== undefined)
            {                             
                return (
                  <TableGroupRow 
                    contentComponent={this.props.groupContentComponent !== undefined ? this.props.groupContentComponent : LocalGroupContentComponent}  
                    cellComponent={this.props.tableGroupRow_cellComponent !== undefined ? this.props.tableGroupRow_cellComponent : LocalTableGroupRow_cellComponent }  
                    showColumnsWhenGrouped={this.props.showColumnsWhenGrouped}
                    columnExtensions = {this.props.tableGroupColumnExtensions}
                    iconComponent={this.props.groupIconComponent === undefined ? LocalGroupIconComponent : this.props.groupIconComponent}
                    containerComponent={LocalcontainerComponent}
                  />
                )            
            }
        })()
        }      
        {
          (() => {
            if (this.props.TableNameTreeColum !== undefined)
            {
           return (
          <TableTreeColumn
            for={this.props.TableNameTreeColum}
            showSelectionControls={this.props.showSelectionControlsTree === undefined ? false : this.props.showSelectionControlsTree}
            showSelectAll={this.props.showSelectAllTree === undefined ? false : this.props.showSelectAllTree}
            checkboxComponent  = {this.props.TableTreeColumn_checkboxComponent === undefined ? LocalTableTreeColumn_checkboxComponent : this.props.TableTreeColumn_checkboxComponent}
            cellComponent={this.props.TableTreeColumn_cellComponent === undefined ? LocalTableTreeColumn_cellComponent : this.props.TableTreeColumn_cellComponent}
            indentComponent={this.props.identComponent === undefined ? LocalIndentComponent : this.props.identComponent}
            expandButtonComponent = { this.props.expandButtonComponent === undefined ? LocalExpandButtonComponent : this.props.expandButtonComponent }
          />        
           )
         }
        })()
        }
        {
            (() => {
	              if (this.props.cellsEditing === true)
                {
                    return (<TableInlineCellEditing
          		                  startEditAction={this.props.startEditAction === undefined ? 'click' : this.props.startEditAction }
          		                  selectTextOnEditStart={this.props.selectTextOnEditStart === undefined ? false: this.props.selectTextOnEditStart}
			                          cellComponent={this.props.cellsEditingCellComponent !== undefined ? this.props.cellsEditingCellComponent : LocalcellsEditingCellComponent }
        	                  />)
                }
            })()
        }
        {
          (()=>{
              if (this.props.totalItems !== undefined || this.props.groupItems !== undefined)
              {
                return(
                  <TableSummaryRow 
                    messages={this.props.summaryRowMessages}
                    totalCellComponent={this.props.totalCellComponent !== undefined ? this.props.totalCellComponent : LocalTotalCellComponent}
                    groupCellComponent={this.props.groupCellComponent !== undefined ? this.props.groupCellComponent : LocalTotalCellComponent}
                    itemComponent={this.props.totalItemComponent !== undefined ? this.props.totalItemComponent : LocalItemComponent}
                  />
                );

              }
          })()
        }
        {
             (() => {
                
              if (this.props.leftColumnsFixed !== undefined || this.props.rightColumnsFixed !== undefined)
              {      
                return (
                <TableFixedColumns
                leftColumns={this.props.leftColumnsFixed}
                rightColumns={this.props.rightColumnsFixed}
                 cellComponent={this.props.columnFixedCellComponent !== undefined  ? this.props.columnFixedCellComponent : LocalColumnFixed_cellComponent}
                />
                )
              }               
            })()
        }
        <Plugin>
         <TableRowsIndexer />
        {
          (() => {
          
            if (this.props.standarPlugin !== undefined){

              return (
                this.props.standarPlugin
              );

            }

          })()

        }
        </Plugin>
        {this.props.enabledExports?
        <Toolbar/>
        :null}
        {this.props.enabledExports ?<ExportPanel  menuComponent={ExportMenu(this.quitarorden,this.state.tiene_orden,this.props.label_Toolbarexport)}
        startExport={this.startExport} />
        :null
        }
        </Grid>
        {/*
        this.props.enabledExports?
        <GridExporter
          ref={this.exporterRef}
          columns={this.props.columns_export}
          rows={this.props.rows_export}
          filters={this.props.enabledFilterRows === true?this.props.Filters:[]}
          onSave={onSave(this.props.name_export)}
        />:null*/
        }
        {this.props.loading && <Loading />}
      </Paper>

    );
  }
}
